<template>
  <div>
    <div class="px-4 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl sm:px-20 md:px-28 lg:px-10" ref="tab">
      <ul class="flex flex-wrap justify-center">
        <li class="w-1/3 text-lg text-center text-gray-500 py-4 px-4 font-medium border-transparent cursor-pointer"
          v-for="(item, index) in tabs" :key="index" :class="{ active: active === index }" @click="switchTab(index)">
          {{item}}
        </li>
      </ul>
    </div>
    <div ref="cont">
      <div class="cont1" ref="cont_1">
        <div
          class="px-4 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl sm:px-20 md:px-28 lg:px-10 sm:py-24 lg:py-24 ">
          <!--    标题      -->
          <div class="flex justify-center items-center">
            <img :src="baseOSSUrl + '/news-1.png'" alt="" class="h-5 w-5">
            <p class="w-32 h-9 text-2xl text-center leading-9 text-lg font-bold tracking-widest text-gray-600">专家库</p>
            <img :src="baseOSSUrl + '/news-1.png'" alt="" class="h-5 w-5">
          </div>
          <div class="flex flex-wrap w-full flex-col items-center text-center mt-5">
            <!--            <p class="lg:w-3/4 w-full leading-relaxed text-gray-400 text-sm">-->
            <!--              以下为EMHUB专家库详情-->
            <!--            </p>-->
          </div>
          <!--    内容      -->
          <div class="mt-10">
            <div class="relative w-full">
              <div class="swiper-container">
                <div class="swiper-wrapper">
                  <div class="swiper-slide rounded-full" v-for="(item, index) in imgList"
                    :style="{'background-image':'url('+item.url+')'}" :key="index">
                  </div>
                </div>
                <div class="swiper-pagination"></div>
              </div>
              <div class="swiper-button-prev"></div>
              <div class="swiper-button-next"></div>
            </div>
            <div class="relative">
              <div class="arrow"></div>
              <div class="w-2/3 mt-10 mx-auto tracking-wide bg-white rounded-lg shadow-md p-8 relative">
                <div class="text-sm border-b border-dotted pb-5"
                  style="color: #333333;font-weight: bold;text-align: center;border-bottom-width: 3px;">
                  <p>{{title}}</p>
                  <p class="pt-2">{{introduce}}</p>
                </div>
                <div v-if="socialFunction!=''">
                  <div class="text-sm titleColor mt-5" style="font-weight: 500;">社会职务</div>
                  <div class="text-sm text-gray-400 mt-5">
                    {{socialFunction}}
                  </div>
                </div>
                <div v-if="academicParticipation!=''">
                  <div class="text-sm titleColor mt-5" style="font-weight: 500;">学术职务</div>
                  <div class="text-sm text-gray-400 mt-5">
                    {{academicParticipation}}
                  </div>
                </div>
                <div v-if="medicalField!=''">
                  <div class="text-sm titleColor mt-5" style="font-weight: 500;">医学领域</div>
                  <div class="text-sm text-gray-400 mt-5">
                    {{medicalField}}
                  </div>
                </div>
                <div v-if="medicalAchievements!=''">
                  <div class="text-sm titleColor mt-5" style="font-weight: 500;">医学成就</div>
                  <div class="text-sm text-gray-400 mt-5">
                    {{medicalAchievements}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div ref="cont_2">
        <div class="px-4 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl sm:px-20 md:px-28 lg:px-10 lg:py-24">
          <div class="flex justify-center items-center">
            <img :src="baseOSSUrl + '/news-1.png'" alt="" class="h-5 w-5">
            <p class="h-9 text-2xl text-center leading-9 text-lg font-bold tracking-widest text-gray-600"
              style="width: 22rem;">多学科会诊/第二诊疗意见</p>
            <img :src="baseOSSUrl + '/news-1.png'" alt="" class="h-5 w-5">
          </div>
          <div class="container cont2">
            <div class="flex flex-wrap my-10">
              <div class="flex-col sm:w-1/2 md:w-1/3">
                <img :src="baseOSSUrl + '/clinical1.png'" class="w-full h-full" alt="">
              </div>
              <div class="flex-col p-4  sm:w-1/2 md:w-2/3 bgColorGray ">
                <p class="text-lg font-medium" style="letter-spacing: 1px;">MDT多学科会诊</p>
                <p class="text-gray-400 text-sm font-normal pt-1 tracking-wide">
                  EMHUB联合国内外顶级医疗资源，包括西班牙最大医疗集团Quiron
                  Salud（费森尤斯集团下属）、西班牙巴塞罗那医院、北京安贞医院等众多国内外知名医疗机构，为患有癌症、神经系统疾病、心血管疾病、肾功能衰竭、骨科等复杂疾病的患者提供多学科联合诊疗（MDT）服务。
                </p>
                <p class="text-gray-400 text-sm font-normal pt-2 tracking-wide">
                  各学科顶级专家将在第一时间综合分析患者病情，通过EMHUB自有的MDT平台，为患者提供全方位的诊疗方案，提高患者的治愈率。
                </p>
              </div>
            </div>

            <div class="flex flex-wrap my-10">
              <div class="flex-col sm:w-1/2 md:w-1/3">
                <img :src="baseOSSUrl + '/clinical2.png'" class="w-full h-full" alt="">
              </div>
              <div class="flex-col p-4 sm:w-1/2 md:w-2/3 bgColorGray">
                <p class="text-lg font-medium " style="letter-spacing: 1px;">第二诊疗意见</p>
                <p class="text-gray-400 text-sm font-normal pt-1 tracking-wide">
                  EMHUB帮助患者快速、高效地在国际医疗平台获取专业的二次诊疗服务。服务覆盖就医全流程，包括远程国际会诊、国际就医绿色通道、海外诊疗方案在国内的落地治疗，以及患者回国后的后续医疗服务等。<br />
                </p>
                <p class="text-gray-400 text-sm font-normal py-2 tracking-wide">
                  EMHUB提供的专业医疗服务内容包括：<br />
                  - 国际远程病理意见；&emsp;&emsp;&emsp;&emsp;&emsp;&emsp; - 国际远程视频会诊；<br />
                  - 国际远程影像意见；&emsp;&emsp;&emsp;&emsp;&emsp;&emsp; - 书面报告；<br />
                  - 国际远程书面会诊；&emsp;&emsp;&emsp;&emsp;&emsp;&emsp; - 境外就诊等。<br />
                </p>
                <p class="text-gray-400 text-sm font-normal tracking-wide">
                  服务亮点：<br />
                  - 协助患者审核所有病历及翻译，提供患者所需的医疗信息；<br />
                  - 医疗信息的收集、处理过程均有严格的隐私保护；<br />
                  - 国际远程会诊通过专业MDT平台进行，患者授权的信息传输及视频会议均能得到有效保护；<br />
                  - 拥有具有医疗背景的服务专员，实现一对一全程跟进，确保为患者提供最好的服务质量。
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="cont3 bgColorGray" ref="cont_3">
        <div
          class="px-4 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl sm:px-20 md:px-28 lg:px-10 sm:py-24 lg:py-24 ">
          <div class="flex justify-center items-center">
            <img :src="baseOSSUrl + '/news-1.png'" alt="" class="h-5 w-5">
            <p class="w-60 h-9 text-2xl text-center leading-9 text-lg font-bold tracking-widest text-gray-600">研究型国际医院
            </p>
            <img :src="baseOSSUrl + '/news-1.png'" alt="" class="h-5 w-5">
          </div>

          <div class="grid gap-5 sm:grid-cols-1 lg:grid-cols-2 mt-10 max-w-screen-md mx-auto mt-10">
            <div class="relative overflow-hidden shadow-md border border-black border-dashed">
              <img class="object-cover w-full contImg" :src="baseOSSUrl + '/hospital1.png'" alt="" />
              <div class="p-6 border-t border-black border-dashed">
                <p class="mb-2 text-sm tracking-wider text-gray-400">
                  <!--                  关于生命健康的研究是最跨学科且具交叉融合特征，临床研究也是生命健康产业创新发展的重要支撑。-->
                  生命健康研究是最跨学科且具交叉融合特征的，临床研究也是生命健康产业发展的重要支撑。作为医药创新产业的关键环节，研究型国际医院对打造可持续发展、具备国际竞争力的医药生态系统，引领生物医药产业发展，建设具有国际影响力的产业创新高地起着重要作用。
                </p>
              </div>
            </div>
            <div class="relative overflow-hidden shadow-md border border-black border-dashed">
              <img class="object-cover w-full contImg" :src="baseOSSUrl + '/hospital2.png'" alt="" />
              <div class="p-6 border-t border-black border-dashed">
                <p class="mb-2 text-sm tracking-wider text-gray-400">
                  研究型医院是推动生物医药产业发展的加速器，也是打造生物医药完整产业链条的关键环节。EMHUB陆续在中国大陆设立研究型国际医院，依托其全球医疗资源以及领军专家（PI），支撑跨国药企开展药物的全球多中心临床试验。
                </p>
              </div>
            </div>
            <!--            <div class="relative overflow-hidden shadow-md border border-black border-dashed">-->
            <!--              <img class="object-cover w-full contImg" :src="baseOSSUrl + '/hospital3.png" alt="" />-->
            <!--              <div class="p-6 border-t border-black border-dashed">-->
            <!--                <p class="mb-2 text-sm tracking-wider text-gray-400">-->
            <!--                  EMHUB聚焦于临床与科研的结合，围绕重点医学研究项目，使临床、教学、科研均处于世界的前沿，从而推动医疗技术发展，培养具有创新能力的复合型人才，全面提升中国现代化医院的建设和发展。-->
            <!--                </p>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    baseOSSUrl
  } from '@/utils/oss';
  import "swiper/dist/css/swiper.css";
  import {
    Swiper
  } from "vue-awesome-swiper";
  export default {
    name: "clinicalTabs",
    data() {
      return {
        baseOSSUrl,
        tabs: ["专家库", "多学科会诊/第二诊疗意见", "研究型国际医院"],
        active: 0,
        cont1: null,
        cont2: null,
        cont3: null,

        mySwiper: null,
        imgList: [{
            url: baseOSSUrl + '/joseLuisPomar.png',
            title: "何塞·路易斯·波马尔博士（Dr. José Luis Pomar）", //标题
            introduce: "巴塞罗那医院心血管外科高级顾问、巴塞罗那大学医学院外科学教授、欧洲心胸外科协会（EACTS）前任主席",
            //社会职务
            socialFunction: "现任巴塞罗那医院心血管外科高级顾问、巴塞罗那大学医学院外科系外科学教授，曾任巴塞罗那医院心血管同种异体移植主任、巴塞罗那医院移植委员会主席、巴塞罗那医院临床研究所副所长等。",
            //学术职务
            academicParticipation: "曾任欧洲心胸外科协会（EACTS）主席、顾问委员；加泰罗尼亚心脏外科学会主席；欧洲心胸外科杂志编辑委员会成员；心脏外科论坛编辑委员会成员；心脏瓣膜病杂志编辑委员会成员；西班牙心脏病杂志编辑委员会成员；西班牙心血管外科学会杂志主编；西班牙心血管外科学会主席欧洲远程医学研究所管理委员会成员；欧洲心血管外科学会会员；心脏外科医生协会会员；心脏外科进展编辑咨询委员会成员；应用心肺病理生理学编辑委员会成员（欧洲心脏研究所官方机构，国际心胸外科学会，世界心脏基金会）；加泰罗尼亚移植组织血管组织获取和移植咨询委员会主席；欧洲胸心外科学院和Bergamo心脏外科学院院长；心血管疾病杂志国际咨询委员会成员；欧洲经皮冠状动脉介入治疗协会（EAPCI）提名委员会成员等众多学术职务。",
            //医学领域
            medicalField: "1969年，发表了第一篇关于一种新药的药理特性的实验论文：LB 46，现在被称为普萘洛尔。1987年底，获得了巴塞罗那大学教授的职位，此后一直致力于心血管科和协调心血管医学研究。何塞·路易斯·波马尔博士（Dr. José Luis Pomar）是欧洲瓣膜修复大师协会的联合理事之一，该协会拥有超过15年的经验，并培训了近2500名外科医生。Pomar教授已经发表了200多篇同行评议文章，并在世界各地最负盛名的会议上发表了600多篇论文和演讲。",
            //医学成就
            medicalAchievements: "获得桑坦德大学（坎塔布里亚）杰出博士奖；与国家微电子和金属碳化物中心合作，获得了2001年巴塞罗那市技术研究奖；聚焦超声在房颤外科治疗中的应用评价临床可行性研究、研究F.I.S.S.同种主动脉瓣绝育术、同种主动脉移植：污染、灭菌和细胞活力的研究、同种异体瓣膜移植的力学分析冷冻保存的影响、绝经期内皮功能障碍雌激素替代治疗的作用机制等获得众多成就。"
          },
          {
            url: baseOSSUrl + '/josepMpique.jpg',
            title: "约瑟夫·皮克博士（Dr.Josep Maria Piqué）", //标题
            introduce: "安道尔公共卫生局首席执行官、西班牙巴塞罗那医院前任院长",
            //社会职务
            socialFunction: "现任职安道尔公共卫生局首席执行官，曾任西班牙巴塞罗那医院院长、巴塞罗那医院肠胃科主任、巴塞罗那医院医务部主任；美国加州大学洛杉矶分校客座教授、巴塞罗那大学医学副教授。",
            //学术职务
            academicParticipation: "美国肠胃病学会会员；西班牙加泰罗尼亚消化学会主席；世界胃肠病组织研究和远程医疗委员会成员；巴塞罗那国际健康论坛主席；全球卫生研究所（ISGlobal）董事会成员；阿拉贡健康科学研究所顾问委员会成员，西班牙肠胃基金会主席。",
            //医学领域
            medicalField: "约瑟夫皮克博士（Dr. Josep M Pique  ）参与了26本书籍的编辑，著作57部，在索引期刊上发表了258篇原创文章，并发表了118篇评论或社论，共引用5162篇。",
            //医学成就
            medicalAchievements: "暂无信息"
          },
          //   {
          //   url: baseOSSUrl + '/josepBrugadaTerradellas.jpg'),
          //   title:"Josep Brugada Terradellas 博士",//标题
          //   introduce:"巴塞罗那大学医学系教授、巴塞罗那医院医务主任",
          //   academicParticipation:"巴塞罗那大学医学和外科博士（优等生），1988年在蒙彼利埃大学获得心脏病专家、运动生物学和医学专家学位，2005年获得综合卫生服务管理硕士学位。目前是巴塞罗那医院的医务主任，圣琼·德杜儿科医院心律失常科科长，欧洲心律失常学会（2005-2009年）前任主席。1998年起任巴塞罗那大学医学系教授。",//学术任职
          //   researchActivity:"已发表300+原创文章，是众多科学协会成员，也是《欧洲心脏杂志》副编辑。在研究领域，1992年他与他的兄弟一起发现并提出了在医学文献中被称为布鲁加德综合征的猝死综合征。",//研究活动
          // },
          {
            url: baseOSSUrl + '/martaSitges.png',
            title: "玛尔塔·锡切斯博士（Dr. Marta Sitges）", //标题
            introduce: "巴塞罗那医院诊所心血管研究所主任",
            //社会职务
            socialFunction: "现任职巴塞罗那医院诊所心血管研究所主任，巴塞罗那大学医学副教授、博士生导师。曾担任巴塞罗那医院心脏成像科主任。",
            //学术职务
            academicParticipation: "西班牙心脏瓣膜协会主席",
            //医学领域
            medicalField: "自2001年以来，玛尔塔·锡切斯博士（Dr. Marta Sitges） 一直在巴塞罗那大学医院诊所担任非侵入性心脏病专家，专注于超声心动图和瓣膜疾病的专业领域，玛尔塔·锡切斯博士（Dr. Marta Sitges）是医院诊所运动心脏病学小组的协调员，自2009年起负责巴塞罗那足球俱乐部的运动心脏病学项目，主要研究方向是心脏成像，再同步治疗，瓣膜心脏病和心脏重塑，以及运动心脏病学。发表了150多篇同行评议论文，参与了150多场演讲，在国内和国际会议上发表了400多篇摘要。",
            //医学成就
            medicalAchievements: "暂无信息"
          },
          //   {
          //   url: baseOSSUrl + '/torstenDoenst.jpg'),
          //   title:"Dr. Torsten Doenst （托斯滕·多恩斯特 )",//标题
          //   introduce:"心血管外科专家",
          //   academicParticipation:"斯滕·多恩斯特教授（1969年2月28日生于哥廷根）是国际著名的心脏外科医生和科学家。",//学术任职
          //   researchActivity:"自2015年起担任德国心脏外科教授发言人，自2018年起担任耶拿大学医院院长发言人。此外，多恩斯特教授同时负责德国胸及心血管外科学会委员会的相关事务。",//研究活动
          // },
          //   {
          //   url: baseOSSUrl + '/rainerHambrecht.jpg'),
          //   title:"Dr. Rainer Hambrecht (莱纳 ·哈姆布莱希特),心血管外科专家\n",//标题
          //   academicParticipation:"哈姆布莱希特教授担任不来梅威悉河左岸医院心脏中心第二医疗诊所主任医师 ",//学术任职
          //   researchActivity:"德国心脏病学会预防工作小组组长和发言人。1999-2006年欧洲心脏病学会心脏康复和运动生理学核心成员。欧洲预防心脏病学会科学会员。德国心脏基金会科学咨询委员会成员。",//研究活动
          // },
          //   {
          //   url: baseOSSUrl + '/eikeSebastianDebus.jpg'),
          //   title:"Dr. Eike Sebastian Debus(埃克·塞巴斯甜·德布斯 ），心血管外科专家",//标题
          //   academicParticipation:"诊所主任 ，德国血管外科和血管医学协会（DGG）专家",//学术任职
          //   researchActivity:"普通外科、腹部手术(内脏手术)、血管外科、静脉学",//研究活动
          // },
          //   {
          //   url: baseOSSUrl + '/hs.jpg'),
          //   title:"汉斯-海宁·埃科施泰恩，心血管外科专家",//标题
          //   academicParticipation:"原在慕尼黑工业大学担任新设血管和血管内外科主任 2009/2010年担任德国血管外科和血管医学协会（DGG）主席 ",//学术任职
          //   researchActivity:"主要研究颈动脉不稳定的动脉硬化斑块狭窄和主动脉瘤疾病的成因和破裂的风险等相关问题。",//研究活动
          // },
          //   {
          //   url: baseOSSUrl + '/hermannReichenspurner.jpg'),
          //   title:"Dr. Hermann Reichenspurner（赫尔曼·亥辛斯普尔纳），心血管外科专家，德国汉堡大学心脏中心医学部副主任",//标题
          //   academicParticipation:"微创心脏手术、 主动脉手术、人工心脏系统使用、心脏和肺部移植",//学术任职
          //   researchActivity:"",//研究活动
          // },
          {
            url: baseOSSUrl + '/xavierRuyra.png',
            title: "泽维尔·鲁伊拉博士（Dr. Xavier Ruyra）", //标题
            introduce: "巴塞罗那Teknon医疗中心心脏健康研究所所长",
            //社会职务
            socialFunction: "现任巴塞罗那Teknon医疗中心心脏健康研究所所长、巴塞罗那医院心脏外科医生、巴塞罗那大学的副教授。曾任职加利西亚技术医学院（MEDTEC）心脏外科主任、巴达洛纳大学医院和吉罗纳大学医院心脏外科主任。",
            //学术职务
            academicParticipation: "暂无信息",
            //医学领域
            medicalField: "欧洲心胸外科协会委员、西班牙心脏外科学会会员；泽维尔·鲁伊拉博士（Dr. Xavier Ruyra）的专长是心脏瓣膜修复手术、无血心脏手术、Ross手术和治疗高危患者主动脉瓣病变的新选择，曾多次在大会上发表演讲，并在专业期刊上发表论文，在心脏外科领域拥有多项专利。",
            //医学成就
            medicalAchievements: "Cardio Dream项目的推动者、创始人和主席，CardioDream是一个非营利性基金会，为那些既没有资源也没有护理机会的患者提供服务。CardioDream的目标是将生活在发展中国家的严重心脏病患者转移到巴塞罗那进行手术，并推动和促进改善心血管健康的行动，特别是妇女。泽维尔·鲁伊拉博士（Dr. Xavier Ruyra）超过15000次手术和25年的行业经验被认为是西班牙五大心血管外科医生之一，因为他们的干预措施涵盖了整个风险范围和所有现代心脏手术。"
          },
          {
            url: baseOSSUrl + '/lcy.png',
            title: "卢才义 教授、博士生导师", //标题
            introduce: "广州巴塞罗那医院心脏中心主任",
            //社会职务
            socialFunction: "现任职广州巴塞罗那医院心脏中心主任，曾任解放军总医院老年心血管病研究所、解放军总医院心血管内科主任、空军总医院副院长。",
            //学术职务
            academicParticipation: "中华医学会心脏起搏与电生理分会青年委员；中国生物医学工程学会心脏起搏与电生理分会青年委员；全军老年医学专业委员会常委及秘书长；全军心血管内科专业委员会委员；中华预防医学会自由基学会常委；中国医疗国际促进会心血管病专业委员会委员，中国华医学会介入心脏病学培训中心委员。",
            //医学领域
            medicalField: "从事心血管内科临床和基础研究工作30年，从事心血管病介入诊断和治疗工作20年，能高质量完成各类心脏起搏器植入手术（包括目前最新的CRT和CRT-D等植入技术难度较大的起搏器植入手术）、高龄高危和复杂冠心病介入治疗手术、各种心律失常射频消融手术、外周血管病介入手术、心血管病联合介入手术等心血管内科的介入诊疗手术。是国内为数不多的集多种介入手术操作技术于一身的“全能型”心血管介入专家之一。国家实用新型专利心血管介入注射器、带有安全定位和快速交换结构的先心病封堵器组件、一种植入式智能血压调节装置等发明人，《临床心血管操作技术》、《临床心电监测快速诊断学》、《临床心律失常学》等主编著作10余部，发表了400余份学术论文。",
            //医学成就
            medicalAchievements: "获国家人事部、科技部和卫生部联合授予的“全国百名医学科技之星”称号、空军“优秀医务人员”称号、解放军总医院“特殊贡献奖”、解放军总医院“中青年研究型人才”、四次荣立三等功、享受政府特殊津贴。"
          },
          {
            url: baseOSSUrl + '/dabit.png',
            title: "达比·阿尔扎门迪博士（Dr. Dabit Arzamendi）", //标题
            introduce: "介入性心脏病专家、巴塞罗那自治大学的副教授",
            //社会职务
            socialFunction: "现任Sant Paul医院和Teknon医疗中心冠状动脉介入治疗和结构性心脏病助理，巴塞罗那自治大学的副教授、圣安东尼奥天主教大学西班牙心脏病学会血流动力学在线硕士教授。",
            //学术职务
            academicParticipation: "西班牙心脏病学会会员；欧洲心脏病学会会员；西班牙心脏病学会血流动力学科成员；巴塞罗那冠状动脉和结构课程大会科学委员会组织者（2015-2018年）；心血管导管介入术和西班牙心脏病杂志的定期审稿人；美国心脏病学杂志客座编辑；达比·阿尔扎门迪博士（Dr. Dabit Arzamendi） 参与了为国家和国际科学期刊和出版物撰写和出版多篇文章，曾担任最高级别的国家和国际会议（TCT、PCR、SEC、CSC）的报告员。",
            //医学领域
            medicalField: "达比·阿尔扎门迪博士（Dr. Dabit Arzamendi） 是介入心脏病学专家，是经皮或微创瓣膜介入治疗的国家参考文献之一。达比·阿尔扎门迪博士（Dr. Dabit Arzamendi）是经皮治疗主动脉瓣、二尖瓣和三尖瓣的专家，专门研究通过修复心内间隔缺损（CIA和FOP）和闭合左附件来减少中风（脑栓塞）的治疗，以及在冠心病治疗方面有着丰富的经验，包括复杂冠状动脉病变的治疗，是经皮或微创瓣膜干预的国家参考之一，曾为国家和国际科学期刊发表过许多文章。",
            //医学成就
            medicalAchievements: "获西班牙心脏病学会外国中心培训奖学金、阿隆索·马丁·埃斯库德罗基金会外国中心培训奖学金、蒙特利尔心脏研究所冠状动脉和结构介入研究金、蒙特利尔圣贾斯汀医院儿科心脏介入研究金、波士顿马萨诸塞州总医院结构心脏干预研究金等。"
          },
          {
            url: baseOSSUrl + '/danielPereda.jpg',
            title: "丹尼尔·佩雷达博士（Dr. Daniel Pereda）", //标题
            introduce: "巴塞罗那医院心血管外科顾问医生",
            //社会职务
            socialFunction: "现任巴塞罗那医院和Teknon医疗中心的心脏外科医生、巴塞罗那大学的副教授。",
            //学术职务
            academicParticipation: "美国约翰霍普金斯医院(Johns Hopkins Hospital)担任成人心脏外科研究员",
            //医学领域
            medicalField: "从事微创心血管手术（Port Access手术）、机器人心脏手术、二尖瓣和主动脉瓣修复和房颤手术、马凡病手术、儿童和成人先天性心脏病修复、机械循环辅助装置和心脏移植等手术的专家。",
            //医学成就
            medicalAchievements: "暂无资料"
          }, {
            url: baseOSSUrl + '/jeroenBax.png',
            title: "杰罗恩·巴克斯博士（Dr. Jeroen Bax）", //标题
            introduce: "莱顿大学医学中心心脏病学教授、无创成像和回声实验室主任、欧洲心脏病协会前任主席",
            //社会职务
            socialFunction: "现任莱顿大学医学中心心脏病学系回声实验室主任、莱顿大学医学中心心脏病学系无创成像主任、莱顿大学心脏病学医学教授。",
            //学术职务
            academicParticipation: "曾任欧洲心脏病学会大会项目委员会主席；欧洲心脏病学会候任主席；欧洲心脏病学会主席；担任过各种期刊的编辑委员会成员，包括《美国心脏病学会杂志》的副主编和欧洲心脏病学会（ESC）会长，曾以多种身份为ESC服务，包括心脏病学实践指南委员会主席、科学项目主席、新闻委员会主席、两次国际核心脏病学会议（ICNC）联合主席。",
            //医学领域
            medicalField: "临床心脏病学、心力衰竭、心脏再同步治疗以及所有不同成像方式在这些临床领域的应用。在国际同行评议期刊上发表了700多篇论文，两本ESC心脏成像书籍的联合编辑。",
            //医学成就
            medicalAchievements: "美国心脏病学会2020年杰出科学家奖（临床领域）; 2019年ASNC杰出服务奖，表彰对心血管成像和心脏病学的贡献; 2008年ESC银牌; 2008年美国心脏病学院道格拉斯·P·齐普斯奖。莱顿大学医学中心（LUMC）的心脏成像研究中心指导了60多名国际博士生，在世界各地的医疗机构取得了卓越的成就。"
          },
        ],
        title: "何塞·路易斯·波马尔博士（Dr. José Luis Pomar）", //选中的标题
        introduce: "巴塞罗那医院心血管外科高级顾问、巴塞罗那大学医学院外科学教授、欧洲心胸外科协会（EACTS）前任主席",
        //社会职务
        socialFunction: "现任巴塞罗那医院心血管外科高级顾问、巴塞罗那大学医学院外科系外科学教授，曾任巴塞罗那医院心血管同种异体移植主任、巴塞罗那医院移植委员会主席、巴塞罗那医院临床研究所副所长等。",
        //学术职务
        academicParticipation: "曾任欧洲心胸外科协会（EACTS）主席、顾问委员；加泰罗尼亚心脏外科学会主席；欧洲心胸外科杂志编辑委员会成员；心脏外科论坛编辑委员会成员；心脏瓣膜病杂志编辑委员会成员；西班牙心脏病杂志编辑委员会成员；西班牙心血管外科学会杂志主编；西班牙心血管外科学会主席欧洲远程医学研究所管理委员会成员；欧洲心血管外科学会会员；心脏外科医生协会会员；心脏外科进展编辑咨询委员会成员；应用心肺病理生理学编辑委员会成员（欧洲心脏研究所官方机构，国际心胸外科学会，世界心脏基金会）；加泰罗尼亚移植组织血管组织获取和移植咨询委员会主席；欧洲胸心外科学院和Bergamo心脏外科学院院长；心血管疾病杂志国际咨询委员会成员；欧洲经皮冠状动脉介入治疗协会（EAPCI）提名委员会成员等众多学术职务。",
        //医学领域
        medicalField: "1969年，发表了第一篇关于一种新药的药理特性的实验论文：LB 46，现在被称为普萘洛尔。1987年底，获得了巴塞罗那大学教授的职位，此后一直致力于心血管科和协调心血管医学研究。何塞·路易斯·波马尔博士（Dr. José Luis Pomar）是欧洲瓣膜修复大师协会的联合理事之一，该协会拥有超过15年的经验，并培训了近2500名外科医生。Pomar教授已经发表了200多篇同行评议文章，并在世界各地最负盛名的会议上发表了600多篇论文和演讲。",
        //医学成就
        medicalAchievements: "获得桑坦德大学（坎塔布里亚）杰出博士奖；与国家微电子和金属碳化物中心合作，获得了2001年巴塞罗那市技术研究奖；聚焦超声在房颤外科治疗中的应用评价临床可行性研究、研究F.I.S.S.同种主动脉瓣绝育术、同种主动脉移植：污染、灭菌和细胞活力的研究、同种异体瓣膜移植的力学分析冷冻保存的影响、绝经期内皮功能障碍雌激素替代治疗的作用机制等获得众多成就。"
      }
    },
    components: {
      Swiper
    },
    methods: {
      switchTab(index) { // 根据当前index切换到对应的页面内容
        if (index === 0) {
          this.active = 0;
          this.cont1.scrollIntoView({
            block: "start",
            behavior: "smooth"
          });
        } else if (index === 1) {
          this.active = 1;
          this.cont2.scrollIntoView({
            block: "start",
            behavior: "smooth"
          });
        } else {
          this.active = 2;
          this.cont3.scrollIntoView({
            block: "start",
            behavior: "smooth"
          });
        }
      }
    },
    mounted() {
      var that = this;
      that.cont1 = that.$refs["cont_1"];
      that.cont2 = that.$refs["cont_2"];
      that.cont3 = that.$refs["cont_3"];
      const tabH = that.$refs["tab"].offsetHeight;
      // 添加scroll事件监听
      window.addEventListener("scroll", () => {
        if (that.cont3.getBoundingClientRect().top <= tabH) {
          that.active = 2;
          return false;
        }
        if (that.cont2.getBoundingClientRect().top <= tabH) {
          that.active = 1;
          return false;
        }
        if (that.cont1.getBoundingClientRect().top <= tabH) {
          that.active = 0;
        }
      });

      //异型轮播图
      that.mySwiper = new Swiper('.swiper-container', {
        initialSlide: 0,
        slidesPerView: 3,
        // spaceBetween: 30,
        centeredSlides: true,
        // autoplay: {
        //   delay: 1000,
        //   disableOnInteraction: false, // 用户操作后不禁止autoplay
        // },
        loop: true,
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true,
        // },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        //改变事件
        on: {
          slideChange: function () {
            var activeIndex = this.activeIndex;
            var length = that.imgList.length;
            var index = (activeIndex - 3) % length;
            if (index == -1) {
              index = length - 1
            }
            that.imgList.forEach((item, $index) => {
              if (`${$index}` == index) {
                that.title = `${item.title}`;
                that.introduce = `${item.introduce}`;
                that.socialFunction = `${item.socialFunction}`;
                that.academicParticipation = `${item.academicParticipation}`;
                that.medicalField = `${item.medicalField}`;
                that.medicalAchievements = `${item.medicalAchievements}`;
              }
            })
          },
        },
      });

    },
    destroyed() {
      window.removeEventListener("scroll", () => {}, true)
    },
  }
</script>

<style scoped>
  .active {
    box-sizing: border-box;
    border-bottom-width: 2px;
    border-color: #123B7F;
  }

  .cont1 {
    background-color: #F1F4FB;
  }

  .swiper-container {
    width: 600px;
    height: 200px;
    /*background: #fff;*/
  }

  .swiper-container .swiper-slide {
    text-align: center;
    font-size: 18px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    transition: all .2s ease;
  }

  .swiper-container .swiper-slide:not(.swiper-slide-active) {
    transform: scale(.8);
  }

  .swiper-container .swiper-slide.swiper-slide-prev {
    transform-origin: left center;
  }

  .swiper-container .swiper-slide.swiper-slide-next {
    transform-origin: right center;
  }

  /* button按钮的设置 */
  .swiper-button-next:after,
  .swiper-button-prev:after {
    font-size: 30px;
    /* 大小设置 */
    color: #fff;
    /* 颜色设置 */
  }

  /* 分页器设置 */
  .swiper-pagination-bullet {
    height: 4px;
    width: 16px;
    margin: 0 10px !important;
    border-radius: 1px;
  }

  .swiper-pagination-bullet-active {
    background: #fff;
    /* 颜色设置 */
  }

  .titleColor {
    color: #123B7F;
  }

  .titleColor::before {
    content: "";
    position: absolute;
    left: 1rem;
    border: 1px solid #123B7F;
    background-color: #123B7F;
    display: inline-block;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    margin-top: 0.375rem;
  }

  .arrow {
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid;
    position: absolute;
    border-bottom-color: white;
    left: 50%;
    top: -0.25rem;
    transform: translate(-50%, -50%);
    z-index: 100;
  }

  .bgColorGray {
    background: #F1F4FB;
  }

  .swiper-button-next,
  .swiper-container-rtl .swiper-button-prev {
    background-image: url("//emhub-static-assets3.oss-cn-hangzhou.aliyuncs.com/right.png");
    background-size: 27px;
    right: 230px;
    left: auto;
  }

  .swiper-button-prev,
  .swiper-container-rtl .swiper-button-next {
    background-image: url("//emhub-static-assets3.oss-cn-hangzhou.aliyuncs.com/left.png");
    background-size: 27px;
    left: 230px;
    right: auto;
  }
</style>